module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.evaluationType.evaluation_opened || _vm.evaluationType.evaluation_finished) ? _c('table', {
    staticClass: "table-confirmation",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Atribuir Avaliadores")]), _vm._v(" "), _c('th', [(!_vm.evaluationType.evaluation_finished) ? _c('el-button', {
    attrs: {
      "type": "success",
      "size": "mini"
    },
    on: {
      "click": _vm.addSingleAppraiser
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" "), _c('span', [_vm._v("Adicionar Avaliador")])]) : _vm._e()], 1)])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('el-form', {
    ref: "formPaper",
    attrs: {
      "model": _vm.paper,
      "label-width": "20%"
    }
  }, [_vm._l((_vm.appraisers), function(item, index) {
    return _c('el-form-item', {
      staticClass: "is-required",
      class: {
        'el-form-item--error': _vm.$v.appraisers.$each[index].appraiser_id.$error
      },
      attrs: {
        "label": "Avaliador"
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_c('el-select', {
      staticClass: "el-select-full",
      attrs: {
        "clearable": "",
        "filterable": "",
        "placeholder": "Digite o nome do avaliador",
        "no-data-text": "Nenhum registro encontrado",
        "no-match-text": "Nenhum registro encontrado"
      },
      on: {
        "change": _vm.selectAppraiser,
        "input": function($event) {
          _vm.$v.appraisers.$each[index].appraiser_id.$touch()
        }
      },
      model: {
        value: (item.appraiser_id),
        callback: function($$v) {
          _vm.$set(item, "appraiser_id", $$v)
        },
        expression: "item.appraiser_id"
      }
    }, _vm._l((_vm.dependencies.filteredAppraisers), function(item) {
      return _c('el-option', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item.show && item.evaluation_types.some(function (obj) { return obj.evaluation_type_id === _vm.evaluationType.evaluation_type_id; })),
          expression: "item.show && item.evaluation_types.some(obj => obj.evaluation_type_id === evaluationType.evaluation_type_id)"
        }],
        key: item.id,
        staticClass: "el-select-appraisers",
        attrs: {
          "label": item.name,
          "value": item.id
        }
      }, [_c('div', {
        staticClass: "item-name"
      }, [_vm._v(_vm._s(item.name) + " (" + _vm._s(item.ref_pessoa) + ")\n                                    ")]), _vm._v(" "), (item.knowledge_areas.length > 0) ? _c('div', {
        staticClass: "item-description"
      }, [_vm._v("\n                                         Graduação: " + _vm._s(item.grade)), _c('br'), _vm._v("\n                                         Áreas de Conhecimento: " + _vm._s(item.knowledge_areas.map(function (obj) { return obj.knowledge_area.name; }).join(', ')) + "\n                                    ")]) : _vm._e()])
    })), _vm._v(" "), (!_vm.$v.appraisers.$each[index].appraiser_id.required && _vm.$v.appraisers.$each[index].appraiser_id.$dirty) ? _c('validation-message') : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [(!_vm.evaluationType.evaluation_finished) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini",
        "title": "Remover Avaliador"
      },
      on: {
        "click": function($event) {
          _vm.removeAppraiser(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]) : _vm._e()], 1)], 1)], 1)
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.isSubmitted || _vm.$v.appraisers.$invalid
    },
    on: {
      "click": _vm.onAssignAppraisers
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('span', [_vm._v("Atribuir Avaliadores")])])], 1)], 2)], 1)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-91b78d8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/show/paper/evaluation/Appraisers.vue
// module id = 777
// module chunks = 2